// Libraries
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const renderWeight = (weight, values) => {
  const { id, label } = weight;
  const count = values[id]?.count || 0;
  const percentage = values[id]?.percentage || 0;

  return (
    <div key={weight.id} className="custom-tooltip__label">
      {`${label}: `}
      <span className="custom-tooltip__value">{`${count} (${percentage}%)`}</span>
    </div>
  );
};

const MatrixTooltip = ({ active, payload, label, weights }) => {
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (tooltipRef && tooltipRef.current) {
      const elemClientRect = tooltipRef.current.getBoundingClientRect();
      const maxWidth = document.body.clientWidth - elemClientRect.x - 10;

      if (elemClientRect.width > maxWidth) {
        tooltipRef.current.style.width = `${maxWidth}px`;
      }
    }
  });

  if (active && payload) {
    const values = payload[0]?.payload.values || {};

    return (
      <div ref={tooltipRef} className="custom-tooltip">
        <div className="custom-tooltip__label">
          <span>{label}</span>
        </div>
        {weights.map((weight) => renderWeight(weight, values))}
      </div>
    );
  }

  return null;
};

MatrixTooltip.defaultProps = {
  active: false,
  payload: [],
  label: '',
};

MatrixTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      payload: PropTypes.shape({
        values: PropTypes.objectOf(
          PropTypes.shape({
            count: PropTypes.number.isRequired,
            percentage: PropTypes.number.isRequired,
          })
        ),
      }),
    })
  ),
  label: PropTypes.string,
  weights: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default MatrixTooltip;
